import { render, staticRenderFns } from "./Downgrade.vue?vue&type=template&id=3e00229e&"
import script from "./Downgrade.vue?vue&type=script&lang=js&"
export * from "./Downgrade.vue?vue&type=script&lang=js&"
import style0 from "./Downgrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports